import { render, staticRenderFns } from "./goodsQualityControl.vue?vue&type=template&id=9b967c46&scoped=true&"
import script from "./goodsQualityControl.vue?vue&type=script&lang=js&"
export * from "./goodsQualityControl.vue?vue&type=script&lang=js&"
import style0 from "./goodsQualityControl.vue?vue&type=style&index=0&id=9b967c46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b967c46",
  null
  
)

export default component.exports